module.exports = __webpack_public_path__ + "media/reference_check/images/help_you_page-7506e01a05230a148bd1f463164f3a8a.svg";